module.exports = __webpack_public_path__ + "media/loader_desk_def.e24e9931.ogg";